import classNames from 'classnames';

import { Button } from './button';
import { ButtonProps } from './button.types';
import { BUTTON_VARIANT_CTA } from './config';

export const ButtonCta = ({ disabled, children, className, borderClasses, paddingClasses, ...props }: ButtonProps) => {
  return (
    <Button
      disabled={disabled}
      className={classNames(
        'flex gap-x-1 justify-center items-center',
        {
          'border-transparent': !borderClasses,
          '': disabled,
        },
        `${borderClasses} ${className}`,
        paddingClasses
      )}
      {...props}
      variant={BUTTON_VARIANT_CTA}>
      {children}
    </Button>
  );
};
